import { render } from "./main-error.vue?vue&type=template&id=557cbb08"
import script from "./main-error.vue?vue&type=script&lang=js"
export * from "./main-error.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__